var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24860_7487)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58523 0 0 3.58523 0 8C0 12.4148 3.58523 16 8 16C12.4148 16 16 12.4148 16 8C16 3.58523 12.4148 0 8 0ZM8 0.615385C12.0818 0.615385 15.3846 3.91815 15.3846 8C15.3846 12.0818 12.0818 15.3846 8 15.3846C3.91815 15.3846 0.615385 12.0818 0.615385 8C0.615385 3.91815 3.91815 0.615385 8 0.615385ZM11.3871 5.93723C11.3177 5.93763 11.2504 5.96149 11.1963 6.00492L6.52862 9.60554L4.86092 7.54215C4.83623 7.50888 4.80506 7.48094 4.7693 7.46C4.73354 7.43906 4.69392 7.42557 4.65281 7.42032C4.61171 7.41507 4.56997 7.41818 4.53009 7.42946C4.49022 7.44074 4.45304 7.45996 4.42077 7.48596C4.38851 7.51196 4.36183 7.54421 4.34233 7.58078C4.32284 7.61735 4.31093 7.65747 4.30732 7.69876C4.30372 7.74004 4.30849 7.78162 4.32134 7.82101C4.3342 7.86041 4.35489 7.8968 4.38215 7.928L6.42769 10.4615L11.5735 6.49169C11.6253 6.45285 11.6636 6.39866 11.6828 6.33684C11.702 6.27502 11.7012 6.20871 11.6805 6.14736C11.6599 6.086 11.6204 6.03273 11.5677 5.99511C11.515 5.9575 11.4518 5.93746 11.3871 5.93785V5.93723Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24860_7487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuessIcon);
export default __webpack_public_path__ + "static/media/guess_icon.f3e439e98f3c884524ea97a0671cb7f5.svg";
export { ForwardRef as ReactComponent };